// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js!./order-redesign.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("cb932e66", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/order-redesign.css
// module id = 2093
// module chunks = 0